import { Control, Controller } from 'react-hook-form';

import { DateInput } from '@/components';
import { DateInputProps } from '../inputs/DateInput';

export interface FormDateInputProps
  extends Omit<DateInputProps, 'value' | 'onChange'> {
  control: Control<any>;
  name: string;
  placeholder: string;
  disabled?: boolean;
  required?: boolean;
  autoFocus?: boolean;
}

const FormDateInput = ({
  control,
  name,
  placeholder,
  disabled = false,
  required = false,
  autoFocus = false,
  ...props
}: FormDateInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <DateInput
          {...field}
          {...props}
          placeholder={placeholder}
          disabled={disabled}
          autoFocus={autoFocus}
          required={required}
          error={!!error || props.error}
          errorInfo={error?.message || props.errorInfo}
          onBlur={() => {
            field.onBlur();
            props.onBlur?.();
          }}
        />
      )}
    />
  );
};

export default FormDateInput;
